import React from "react";
import { Mic } from "lucide-react";
import { useAppStore } from "@/hooks/useAppStore";
import { useTranslation } from "@/lib/translate";

export const InputModeToggle: React.FC = () => {
  const inputMode = useAppStore((state) => state.inputMode);
  const setInputMode = useAppStore((state) => state.setInputMode);
  const preferredLanguage = useAppStore((state) => state.preferredLanguage);
  const isVADEnabled = useAppStore((state) => state.isVADEnabled);
  const t = useTranslation(preferredLanguage);

  const toggleInputMode = () => {
    if (isVADEnabled) return;
    setInputMode(inputMode === "mic" ? "keyboard" : "mic");
  };

  return (
    <button
      onClick={toggleInputMode}
      disabled={isVADEnabled}
      title={isVADEnabled ? t("Disabled in Voice Detection mode") : (inputMode === "mic" ? t("Switch to keyboard") : t("Switch to microphone"))}
      style={{
        width: '40px',
        height: '40px',
        border: '2px solid rgba(0, 0, 0, 0.25)',
        background: 'rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(10px)',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: isVADEnabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        opacity: isVADEnabled ? 0.5 : 1,
      }}
      onMouseEnter={(e) => {
        if (isVADEnabled) return;
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.5)';
        e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.4)';
        e.currentTarget.style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        if (isVADEnabled) return;
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
        e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.25)';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      {inputMode === "mic" ? (
        // Keyboard icon using CSS
        <div
          style={{
            width: '20px',
            height: '14px',
            border: '2px solid #333',
            borderRadius: '3px',
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              bottom: '2px',
              left: '3px',
              right: '3px',
              height: '2px',
              background: '#333',
              borderRadius: '1px',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '2px',
              left: '2px',
              right: '2px',
              height: '4px',
              background: 'linear-gradient(to right, #333 20%, transparent 20%, transparent 40%, #333 40%, #333 60%, transparent 60%, transparent 80%, #333 80%)',
            }}
          />
        </div>
      ) : (
        // Mic icon
        <Mic className="h-5 w-5" style={{ color: '#333' }} />
      )}
    </button>
  );
};
